import React from "react";
import style from "./index.module.scss";
import { Divider } from "antd";
import { CloudDeskExperimentListItem } from "API/navExperiment";
import { useHistory } from "react-router-dom";

interface ExperiItemProps {
    data: CloudDeskExperimentListItem; //项目列表项数据
    className?: string; //样式
    imgUrl: string; //图片地址
}

export default function ExperimentItem({
    data,
    className,
    imgUrl
}: ExperiItemProps) {
    const history = useHistory();

    return (
        <div
            className={`${style.root} ${className}`}
            onClick={() => history.push(`/experiment/detail/${data.id}`)}>
            <div className={style.main}>
                <img className={style.img} src={imgUrl} alt="" />

                <div className={style.info}>
                    <div className={style.courseName}>{data.projectName}</div>
                    <div className={style.otherInfo}>
                        <span>项目编码</span>
                        <Divider type="vertical" />
                        <span>{data.projectNo}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
